// extracted by mini-css-extract-plugin
export default {"container":"home_container__IUqqU","flex_x":"home_flex_x__MII6v","content":"home_content__M1rIw","bottom":"home_bottom__P5sSZ"};